import { Navigate, Routes, Route } from 'react-router-dom';
import { Daily } from './pages/Daily';
import { AppProvider } from './context/AppContext';
import './App.css';

export function App() {
    return (
        <AppProvider>
            <div className="app">
                <Routes>
                    <Route path="/" element={<Navigate to="/daily" replace />} />
                    <Route path="/daily" element={<Daily />} />
                    <Route path="/day/:date" element={<Daily />} />
                    <Route path="*" element={<Navigate to="/daily" replace />} />
                </Routes>
            </div>
        </AppProvider>
    );
}
